import { Observable } from 'rxjs/Observable';
import incrementAsyncActionsCount from '../actions/incrementAsyncActionsCountAction';
import decreaseAsyncActionsCount from '../actions/decreaseAsyncActionsCountAction';

const asyncPendingActions =
    ['GET_CATEGORY_RECOMMENDATION_SONGS_PENDING', 'ADD_SONG_PENDING', 'DELETE_SONG_PENDING', 'FETCH_EVENTS_PENDING',
        'ADD_EVENT_PENDING', 'EDIT_EVENT_PENDING', 'GET_EVENT_INFO_PENDING', 'LOGIN_PENDING', 'RESTORE_SESSION_PENDING',
        'ADD_TEMPLATE_PENDING', 'FETCH_TEMPLATES_PENDING', 'CHANGE_SELECTED_TEMPLATE_PENDING', 'ADD_IMAGE_TO_USER_GALLERY_PENDING',
        'GET_EVENT_SONGS_PENDING', 'GET_EVENT_PDF_PENDING', 'ADD_CATEGORY_PENDING', 'DELETE_CATEGORY_PENDING',
        'EDIT_CATEGORY_PENDING', 'GET_SONGS_MATCHES_PENDING', 'REGISTER_PENDING', 'EDIT_ACTIVITY_TITLE_PENDING',
        'DELETE_ACTIVITY_PENDING', 'GET_SPOTIFY_SUGGESTIONS_PENDING', 'EXPORT_SECTION_TO_SPOTIFY_PENDING', 'GET_PLANNING_FORM_PENDING', 'CLONE_CATEGORY_PENDING',
        'EDIT_SECTION_NOTE_PENDING', 'REORDER_EVENT_SECTIONS_PENDING', 'NEW_SECTION_PENDING', 'EDIT_ACTIVITY_TIME_PENDING',
        'REMOVE_ACTIVITY_TIME_PENDING', 'ADD_NEW_CONTACT_TO_EVENT_PENDING', 'UPDATE_CONTACT_IN_EVENT_PENDING',
        'DELETE_CONTACT_FROM_EVENT_PENDING', 'SEND_EVENT_LINK_EMAIL_TO_HOST_PENDING', 'GET_PLANNING_FORM_PDF_PENDING',
        'PLACE_PAYMENT_TO_VIBO_PENDING', 'CHECK_COUPON_PENDING', 'UPDATE_EVENT_SECTION_RECOMMENDATIONS_PENDING',
        'SET_SCANNER_TEST_MODE_PENDING', 'VIDEOS_FETCHED_PENDING', 'SEND_ZAPIER_EVENT_DETAILS_TRIGGER_PENDING',
        'IMPORT_SPOTIFY_PLAYLIST_PENDING', 'MANUAL_VIDEO_FETCHED_PENDING'];
const asyncFinishedActions =
    [ 'GET_CATEGORY_RECOMMENDATION_SONGS_REJECTED', 'GET_CATEGORY_RECOMMENDATION_SONGS_FULFILLED',
        'ADD_SONG_REJECTED', 'ADD_SONG_FULFILLED', 'DELETE_SONG_REJECTED', 'DELETE_SONG_FULFILLED',
        'FETCH_EVENTS_REJECTED', 'FETCH_EVENTS_FULFILLED', 'ADD_EVENT_REJECTED', 'ADD_EVENT_FULFILLED',
        'EDIT_EVENT_REJECTED', 'EDIT_EVENT_FULFILLED', 'GET_EVENT_INFO_REJECTED', 'GET_EVENT_INFO_FULFILLED',
        'LOGIN_REJECTED', 'LOGIN_FULFILLED', 'RESTORE_SESSION_REJECTED', 'RESTORE_SESSION_FULFILLED',
        'ADD_TEMPLATE_REJECTED', 'ADD_TEMPLATE_FULFILLED', 'FETCH_TEMPLATES_REJECTED', 'FETCH_TEMPLATES_FULFILLED',
        'CHANGE_SELECTED_TEMPLATE_REJECTED', 'CHANGE_SELECTED_TEMPLATE_FULFILLED', 'ADD_IMAGE_TO_USER_GALLERY_REJECTED',
        'ADD_IMAGE_TO_USER_GALLERY_FULFILLED', 'GET_EVENT_SONGS_REJECTED', 'GET_EVENT_SONGS_FULFILLED',
        'GET_EVENT_PDF_FULFILLED', 'GET_EVENT_PDF_REJECTED', 'ADD_CATEGORY_REJECTED', 'ADD_CATEGORY_FULFILLED',
        'DELETE_CATEGORY_REJECTED', 'DELETE_CATEGORY_FULFILLED', 'EDIT_CATEGORY_REJECTED', 'EDIT_CATEGORY_FULFILLED',
        'GET_SONGS_MATCHES_REJECTED','GET_SONGS_MATCHES_FULFILLED', 'REGISTER_REJECTED', 'REGISTER_FULFILLED',
        'EDIT_ACTIVITY_TITLE_REJECTED', 'EDIT_ACTIVITY_TITLE_FULFILLED', 'DELETE_ACTIVITY_REJECTED',
        'DELETE_ACTIVITY_FULFILLED', 'GET_SPOTIFY_SUGGESTIONS_REJECTED', 'GET_SPOTIFY_SUGGESTIONS_FULFILLED', 'EXPORT_SECTION_TO_SPOTIFY_REJECTED', 'EXPORT_SECTION_TO_SPOTIFY_FULFILLED', 'GET_PLANNING_FORM_REJECTED', 'GET_PLANNING_FORM_FULFILLED',
        'CLONE_CATEGORY_REJECTED', 'CLONE_CATEGORY_FULFILLED', 'EDIT_SECTION_NOTE_REJECTED', 'EDIT_SECTION_NOTE_FULFILLED',
        'REORDER_EVENT_SECTIONS_REJECTED', 'REORDER_EVENT_SECTIONS_FULFILLED', 'NEW_SECTION_REJECTED', 'NEW_SECTION_FULFILLED',
        'EDIT_ACTIVITY_TIME_REJECTED', 'EDIT_ACTIVITY_TIME_FULFILLED', 'REMOVE_ACTIVITY_TIME_REJECTED', 'REMOVE_ACTIVITY_TIME_FULFILLED',
        'ADD_NEW_CONTACT_TO_EVENT_REJECTED', 'ADD_NEW_CONTACT_TO_EVENT_FULFILLED',
        'UPDATE_CONTACT_IN_EVENT_REJECTED', 'UPDATE_CONTACT_IN_EVENT_FULFILLED',
        'DELETE_CONTACT_FROM_EVENT_REJECTED', 'DELETE_CONTACT_FROM_EVENT_FULFILLED',
        'SEND_EVENT_LINK_EMAIL_TO_HOST_REJECTED', 'SEND_EVENT_LINK_EMAIL_TO_HOST_FULFILLED',
        'GET_PLANNING_FORM_PDF_REJECTED', 'GET_PLANNING_FORM_PDF_FULFILLED',
        'PLACE_PAYMENT_TO_VIBO_REJECTED', 'PLACE_PAYMENT_TO_VIBO_FULFILLED',
        'CHECK_COUPON_REJECTED', 'CHECK_COUPON_FULFILLED',
        'UPDATE_EVENT_SECTION_RECOMMENDATIONS_REJECTED', 'UPDATE_EVENT_SECTION_RECOMMENDATIONS_FULFILLED',
        'SET_SCANNER_TEST_MODE_REJECTED', 'SET_SCANNER_TEST_MODE_FULFILLED',
        'VIDEOS_FETCHED_REJECTED', 'VIDEOS_FETCHED_FULFILLED', 'MANUAL_VIDEO_FETCHED_REJECTED', 'MANUAL_VIDEO_FETCHED_FULFILLED',
        'SEND_ZAPIER_EVENT_DETAILS_TRIGGER_REJECTED', 'SEND_ZAPIER_EVENT_DETAILS_TRIGGER_FULFILLED',
        'IMPORT_SPOTIFY_PLAYLIST_REJECTED', 'IMPORT_SPOTIFY_PLAYLIST_FULFILLED'];

export function handleAsyncActionPending(action$) {
    return action$.filter(
        action => asyncPendingActions.includes(action.type))
        .switchMap((action) => {
            return Observable.of(
                incrementAsyncActionsCount()
            )
        });
}

export function handleAsyncActionFinished(action$) {
    return action$.filter(
        action => asyncFinishedActions.includes(action.type))
        .switchMap(() =>
            Observable.of(
                decreaseAsyncActionsCount()
            )
        );
}



// WEBPACK FOOTER //
// ./src/epics/asyncActionEpic.js